import { RouterProvider } from "react-router/dom";
import { StaticRouterProvider, type DataRouter, type StaticHandlerContext } from "react-router";
import { StoreProvider } from "./stores/StoreProvider";
import type { RootStore } from "./stores/rootStore";
import { useEffect } from "react";
import { i18next, storedHydrationLocale } from "./i18n";
import { setAnalyticsUser } from "./lib/analytics";

export function App({ router, store, context }: { router: DataRouter; store: RootStore; context?: StaticHandlerContext }) {
	useEffect(() => {
		if (store.auth.user) setAnalyticsUser(store.auth.user);
		const locale = store.auth.user?.locale ?? storedHydrationLocale;
		if (locale === "en" || locale === "zh") void i18next.changeLanguage(locale);
		try {
			const theme = window.localStorage.getItem("muhaha-theme");
			store.ui.setTheme(theme === "dark" || theme === "light" ? theme : store.ui.theme);
		} catch { store.ui.setTheme(store.ui.theme); }
	}, [store]);
	return (
		<StoreProvider store={store}>
			{context ? <StaticRouterProvider router={router} context={context} hydrate={false} /> : <RouterProvider router={router} />}
		</StoreProvider>
	);
}
